import { useSelector } from 'react-redux';
import { useDeviceType } from '@cian/ui-kit';

import { NBSP } from '../../../constants/symbols';
import { selectSuggestionsLoading } from '../../../selectors/suggestions';
import { MIN_CHARS_TO_DISPLAY_SUGGEST } from '../constants';

export const useEmptyListText = (value: string, isDebouncing: boolean): string => {
  const deviceType = useDeviceType();
  const isLoading = useSelector(selectSuggestionsLoading);

  /**
   * Чтобы не показать раньше времени текст о ненайденных результатах, когда идет дебаунс.
   */
  if (isDebouncing) {
    return '';
  }

  if (deviceType !== 'desktop' && value.length < MIN_CHARS_TO_DISPLAY_SUGGEST) {
    return `Ищите акции и${NBSP}скидки по${NBSP}определенному ЖК, банку и${NBSP}застройщику`;
  }

  return isLoading ? '' : 'Не нашли ничего такого, попробуйте написать по-другому';
};
